<template>
    <div class="min-h-screen bg-gray-900 text-white py-3 px-2 sm:py-6 sm:px-4 lg:px-8">
        <div class="max-w-7xl mx-auto">
            <DataListControls v-model:searchText="searchText" v-model:pageSize="pageSize"
                v-model:currentPage="currentPage" collectionName="blogs" @dataUpdate="handleDataUpdate">
                <template #actions>
                    <button @click="openAddForm"
                        class="inline-flex items-center px-3 py-2.5 sm:px-4 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 min-h-[44px] touch-manipulation">
                        <span class="hidden sm:inline">Add Blog</span>
                        <span class="sm:hidden">Add</span>
                    </button>
                </template>
                <template #table>
                    <div class="overflow-x-auto -mx-2 sm:mx-0">
                        <table class="min-w-full divide-y divide-gray-700">
                            <thead class="bg-gray-800">
                                <tr>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
                                        Action</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
                                        Post</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden sm:table-cell">
                                        Status</th>
                                    <!-- <th
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
                                        Description</th> -->

                                </tr>
                            </thead>
                            <tbody class="bg-gray-700 divide-y divide-gray-600">
                                <tr v-for="blog in blogs" :key="blog.id" class="hover:bg-gray-600 align-top">
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm font-medium relative">
                                        <div class="relative inline-block text-left dropdown-container">
                                            <button @click="toggleDropdown(blog.id)"
                                                class="inline-flex items-center justify-center w-10 h-10 sm:w-8 sm:h-8 bg-gray-600 bg-opacity-50 hover:bg-opacity-75 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 touch-manipulation">
                                                <svg class="w-4 h-4 text-gray-300" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                </svg>
                                            </button>

                                            <div v-if="openDropdownId === blog.id"
                                                class="absolute left-0 top-0 mt-10 w-40 bg-gray-800 bg-opacity-95 backdrop-blur-sm border border-gray-600 rounded-lg shadow-lg z-50">
                                                <div class="py-1">
                                                    <button @click="openEditForm(blog); closeDropdown()"
                                                        class="w-full text-left px-4 py-2 text-sm text-blue-400 hover:bg-blue-600 hover:bg-opacity-20 hover:text-blue-300 transition-all duration-200 flex items-center">
                                                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                        Edit
                                                    </button>
                                                    <button @click="openDeleteDialog(blog); closeDropdown()"
                                                        class="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-600 hover:bg-opacity-20 hover:text-red-300 transition-all duration-200 flex items-center">
                                                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 text-white align-top">
                                        <div class="flex items-center">
                                            <div v-if="blog.imageURL" class="h-10 w-16 sm:h-12 sm:w-20 flex-shrink-0 mr-2 sm:mr-3">
                                                <img :src="blog.imageURL" alt="Blog thumbnail"
                                                    class="w-full h-full object-cover rounded" />
                                            </div>
                                            <div v-else
                                                class="h-10 w-16 sm:h-12 sm:w-20 flex-shrink-0 mr-2 sm:mr-3 bg-gray-600 rounded flex items-center justify-center">
                                                <span class="text-xs text-gray-400">No Image</span>
                                            </div>
                                            <div class="min-w-0 flex-1 text-sm sm:text-base">
                                                {{ blog.title || 'N/A' }}
                                            </div>
                                        </div>
                                    </td>

                                    <td class="px-2 sm:px-6 py-3 sm:py-4 whitespace-nowrap hidden sm:table-cell">
                                        <label class="relative inline-flex items-center cursor-pointer">
                                            <input type="checkbox" :checked="blog.status" @change="toggleStatus(blog)"
                                                class="sr-only peer" :disabled="updatingStatus === blog.id">
                                            <div
                                                class="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                                            </div>
                                            <span class="ml-3 text-sm font-medium"
                                                :class="blog.status ? 'text-green-400' : 'text-gray-400'">
                                                {{ blog.status ? 'Active' : 'Inactive' }}
                                            </span>
                                        </label>
                                    </td>
                                    <!-- <td class="px-6 py-4 text-gray-300 max-w-[40rem]">
                                        <div v-html="truncateHtml(blog.description, 160)"></div>
                                    </td> -->

                                </tr>
                                <tr v-if="!blogs.length && !isLoading" class="bg-gray-700">
                                    <td colspan="2" class="px-2 sm:px-6 py-4 text-center text-gray-400 sm:hidden">No Data found</td>
                                    <td colspan="3" class="px-6 py-4 text-center text-gray-400 hidden sm:table-cell">No Data found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </DataListControls>

            <BlogForm :isVisible="showForm" :blogId="selectedBlogId" @onEmitHandleEvent="handleFormEvent" />
            <DeleteConfirmation :isVisible="showDeleteDialog" :deleteId="selectedBlogId" :elementName="selectedBlogName"
                elementCategory="Blog" collectionName="blogs" :isLastRecordOnPage="isLastRecordOnPage"
                @onEmitHandleEvent="handleDeleteEvent" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { doc, updateDoc } from 'firebase/firestore';
import { projectFirestore } from '@/firebase/config';
import DataListControls from '@/components/DataListControls.vue';
import BlogForm from '@/components/BlogForm.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

const searchText = ref('');
const pageSize = ref(10);
const currentPage = ref(1);
const blogs = ref([]);
const showForm = ref(false);
const showDeleteDialog = ref(false);
const selectedBlogId = ref(null);
const selectedBlogName = ref('');
const isLoading = ref(false);
const openDropdownId = ref(null);
const updatingStatus = ref(null);

const isLastRecordOnPage = computed(() => {
    return blogs.value.length === 1 && currentPage.value > 1;
});

const handleDataUpdate = (data) => {
    blogs.value = data;
    isLoading.value = false;
};

const openAddForm = () => {
    selectedBlogId.value = null;
    showForm.value = true;
};

const openEditForm = (blog) => {
    selectedBlogId.value = blog.id;
    showForm.value = true;
};

const openDeleteDialog = (blog) => {
    selectedBlogId.value = blog.id;
    selectedBlogName.value = blog.title || 'Untitled Blog';
    showDeleteDialog.value = true;
};

const toggleDropdown = (blogId) => {
    openDropdownId.value = openDropdownId.value === blogId ? null : blogId;
};

const closeDropdown = () => {
    openDropdownId.value = null;
};

const toggleStatus = async (blog) => {
    try {
        updatingStatus.value = blog.id;
        const newStatus = !blog.status;

        // Update in Firestore
        const blogRef = doc(projectFirestore, 'blogs', blog.id);
        await updateDoc(blogRef, {
            status: newStatus
        });

        // Update local state
        const blogIndex = blogs.value.findIndex(b => b.id === blog.id);
        if (blogIndex !== -1) {
            blogs.value[blogIndex].status = newStatus;
        }

        console.log(`blog ${blog.title} status updated to: ${newStatus ? 'Active' : 'Inactive'}`);
    } catch (error) {
        console.error('Error updating blog status:', error);
        alert(`Failed to update blog status: ${error.message}`);
    } finally {
        updatingStatus.value = null;
    }
};

const handleFormEvent = (event, hasError = false, message = '') => {
    if (event === 'close') {
        showForm.value = false;
    } else if (event === 'created' || event === 'updated') {
        showForm.value = false;
        if (event === 'created') {
            currentPage.value = 1;
        }
    } else if (event === 'error') {
        console.error('Form error:', message);
        alert(`Blog form error: ${message}`);
    }
};

const handleDeleteEvent = (event, hasError = false, message = '') => {
    if (event === 'close') {
        showDeleteDialog.value = false;
    } else if (event === 'deleted') {
        showDeleteDialog.value = false;
        if (isLastRecordOnPage.value) {
            currentPage.value = Math.max(1, currentPage.value - 1);
        }
    } else if (event === 'error') {
        console.error('Delete error:', message);
        alert(`Failed to delete blog: ${message}`);
    }
};

// truncate HTML to plain text and shorten
const truncateHtml = (html = '', max = 160) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    const text = tmp.textContent || tmp.innerText || '';
    if (text.length <= max) return text;
    return text.slice(0, max).trim() + '...';
};
</script>

<style scoped>
tr {
    transition: background-color 0.2s ease;
}

button {
    transition: color 0.2s ease, background-color 0.2s ease;
}

.touch-manipulation {
    touch-action: manipulation;
}

/* Mobile card layout for blog status */
@media (max-width: 640px) {
    .blog-row::after {
        content: '';
        display: block;
        padding: 0.5rem 0.75rem;
        background-color: #374151;
    }
}
</style>